export const mockFiles = [
  {
    id: 'f1',
    project_id: '1',
    file_name: 'Proje_Teklif_Dokumani.pdf',
    file_url: '#',
    file_type: 'application/pdf',
    created_at: '2026-04-15T10:00:00Z',
  },
  {
    id: 'f2',
    project_id: '1',
    file_name: 'Tasarim_Spesifikasyonlari.docx',
    file_url: '#',
    file_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    created_at: '2026-04-16T09:00:00Z',
  },
  {
    id: 'f3',
    project_id: '1',
    file_name: 'Wireframe_v1.fig',
    file_url: '#',
    file_type: 'application/figma',
    created_at: '2026-04-18T11:00:00Z',
  },
  {
    id: 'f4',
    project_id: '1',
    file_name: 'Renk_Paleti.ase',
    file_url: '#',
    file_type: 'application/octet-stream',
    created_at: '2026-04-19T14:00:00Z',
  },
  {
    id: 'f5',
    project_id: '2',
    file_name: 'API_Dokumantasyonu.md',
    file_url: '#',
    file_type: 'text/markdown',
    created_at: '2026-04-10T09:00:00Z',
  },
  {
    id: 'f6',
    project_id: '2',
    file_name: 'Veritabani_Semasi.sql',
    file_url: '#',
    file_type: 'application/sql',
    created_at: '2026-04-11T10:00:00Z',
  },
  {
    id: 'f7',
    project_id: '4',
    file_name: 'Logo_Variasyonlari.ai',
    file_url: '#',
    file_type: 'application/illustrator',
    created_at: '2026-04-22T13:00:00Z',
  },
  {
    id: 'f8',
    project_id: '4',
    file_name: 'Marka_Kilavuzu_v2.pdf',
    file_url: '#',
    file_type: 'application/pdf',
    created_at: '2026-04-25T16:00:00Z',
  },
];

export const fileTypeIcons: Record<string, string> = {
  'application/pdf': 'ri-file-pdf-line',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'ri-file-word-line',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'ri-file-excel-line',
  'text/markdown': 'ri-markdown-line',
  'application/sql': 'ri-database-2-line',
  'application/figma': 'ri-pen-nib-line',
  'application/illustrator': 'ri-pen-nib-line',
  'application/octet-stream': 'ri-file-zip-line',
  'url': 'ri-link',
  'text/plain': 'ri-sticky-note-line',
};

export const fileTypeColors: Record<string, string> = {
  'application/pdf': 'text-red-500 bg-red-50',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'text-blue-500 bg-blue-50',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'text-green-500 bg-green-50',
  'text/markdown': 'text-stone-500 bg-stone-100',
  'application/sql': 'text-amber-500 bg-amber-50',
  'application/figma': 'text-purple-500 bg-purple-50',
  'application/illustrator': 'text-orange-500 bg-orange-50',
  'application/octet-stream': 'text-stone-500 bg-stone-100',
  'url': 'text-blue-500 bg-blue-50',
  'text/plain': 'text-amber-500 bg-amber-50',
};

export const fileTypeLabels: Record<string, string> = {
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel',
  'text/markdown': 'Markdown',
  'application/sql': 'SQL',
  'application/figma': 'Figma',
  'application/illustrator': 'Illustrator',
  'application/octet-stream': 'Dosya',
  'url': 'Bağlantı',
  'text/plain': 'Not',
};